<template>
  <div style=" height: content-box">
    <el-header style="font-size: 12px; ">
      <el-tabs >
        <el-tab-pane v-for="item in pageData" :key="item.id" :label="item.name">
          <component :is="item.content" :itemData="item.data"></component>
        </el-tab-pane>
      </el-tabs>
    </el-header>
  </div>
</template>

<script>
import spgl from "./spsgl.vue";
import spflgl from "./spsflgl.vue";
import spflgl1 from "./spsflgl1.vue";
export default {
  data() {
    return {
      pageData: [
        {
          id: "t01",
          name: "教材介绍",
          content: "spgl",
          data: "教材1"
        },
        {
          id: "t02",
          name: "实验答案",
          content: "spflgl",
          data: "教材2"
        },
        {
          id: "t02",
          name: "习题答案",
          content: "spflgl1",
          data: "教材2"
        }
      ]
    }
  },
  components: {
    spgl,
    spflgl,
    spflgl1
  },
  props: ["itemData"]
};
</script>

<style lang="less" scoped>

  /deep/ .el-tabs__item {
    color: white;
  }
  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
  }

</style>



// WEBPACK FOOTER //
// src/components/jc/index.vue